import { FormFieldSet } from '@bambi/component-library/src/components/forms/layout/FormFieldSet';

import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

export const PayerNoteSettings = () => {
  return (
    <div className="py-2">
      <FormFieldSet
        legend="Notes"
        Fields={
          <>
            <FormFieldController name="dispatcher_notes">
              {({ field }) => {
                return (
                  <FormField
                    label="Dispatcher Notes"
                    type="textarea"
                    inputProps={{
                      ...field,
                      id: 'dispatcher_notes',
                    }}
                    onChange={(e) => {
                      field.onChange(e);
                    }}
                    value={field.value}
                  />
                );
              }}
            </FormFieldController>
            <FormFieldController name="admin_notes">
              {({ field }) => {
                return (
                  <FormField
                    label="Admin Notes"
                    type="textarea"
                    inputProps={{
                      ...field,
                      id: 'admin_notes',
                    }}
                    onChange={(e) => {
                      field.onChange(e);
                    }}
                    value={field.value}
                  />
                );
              }}
            </FormFieldController>
          </>
        }
      />
    </div>
  );
};
